// extracted by mini-css-extract-plugin
export default {"titleText":"EditableTitle_titleText__HS-H9","disabled":"EditableTitle_disabled__QnTjf","titleInput":"EditableTitle_titleInput__MC9UC"};